import api from "./api.config";
const list = (params) => {
    
    return api
        .get(`/api/admin/members`, {
            params
        })
        .then((response) => {
            return response.data;
        });
}
const profile = (id) => {
    
    return api
        .get(`/api/admin/members/profile/${id}`)
        .then((response) => {
            return response.data;
        });
}
const updateStatus = (id, status) => {
    return api
        .post(`/api/admin/members/status/change`, {
            id,
            status
        })
        .then((response) => {
            return response.data;
        });
};

const UsersService = {
    list,
    profile,
    updateStatus
};

export default UsersService;